import * as yup from 'yup';
export const personalInfoSchema = yup.object().camelCase().required().shape({
    id: yup.string().required(),
    firstname: yup.string().required(),
    lastname: yup.string().required(),
    patientEmail: yup.string().nullable(),
    title: yup.string().nullable(),
    address: yup.string().nullable(),
    address2: yup.string().nullable(),
    city: yup.string().nullable(),
    state: yup.string().nullable(),
    zip: yup.string().nullable(),
    phone: yup.string().nullable(),
    avatar: yup.string().nullable().ensure(),
    roleId: yup.number().nullable(),
    teamId: yup.number().nullable(),
    teamName: yup.string().nullable(),
    isSupervisingProvider: yup.boolean().nullable(),
    isSuperUser: yup.boolean().nullable(),
    accessLevel: yup.string().nullable(),
    aegisAccessLevel: yup.string().nullable(),
    inviteStatus: yup.string().nullable()
});
